import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import "../portfolio/styles.css";

const SECTIONS = {
  privacy: {
    title: "Privacy Policy",
    updated: "Last updated: June 2026",
    blocks: [
      ["What this covers", "This policy explains how roshanraykar.com / Rosh's Tribe (\"the site\") handles your information when you browse the portfolio or join the Tribe community."],
      ["Information we collect", "When you sign in with Google we receive your name, email address and profile picture. When you create an account with email and password we store your name, email and a securely hashed version of your password — never the password itself. We also store content you interact with inside the Tribe, such as learning progress, likes and chat messages with the learning tutor."],
      ["How we use it", "Your information is used only to operate the Tribe: signing you in, remembering your learning progress, and showing community content. We do not sell, rent or share your personal data with third parties for marketing."],
      ["Cookies", "We use a single session cookie to keep you signed in. No advertising or tracking cookies are used."],
      ["Third-party services", "Google Sign-In is used for authentication. AI tutoring responses are generated by third-party language-model providers; your chat messages are sent to them solely to generate replies."],
      ["Data retention & deletion", "Your account data is kept while your account is active. To request deletion of your account and data, email hi@rosh.work and it will be removed within 30 days."],
      ["Contact", "Questions about this policy: hi@rosh.work"],
    ],
  },
  terms: {
    title: "Terms of Service",
    updated: "Last updated: June 2026",
    blocks: [
      ["Acceptance", "By accessing this site or joining Rosh's Tribe you agree to these terms. If you do not agree, please do not use the site."],
      ["The service", "The site provides a design portfolio and a private community (\"the Tribe\") with learning content, downloads, reels and an AI tutor. Content is provided for personal, non-commercial learning use."],
      ["Your account", "You are responsible for keeping your login credentials secure and for all activity under your account. You must provide accurate information when registering."],
      ["Acceptable use", "You agree not to misuse the service — including attempting unauthorised access, scraping member content, redistributing paid or members-only materials, or using the AI tutor for unlawful purposes."],
      ["Content ownership", "All portfolio work, modules, downloads and community content remain the intellectual property of Roshan Raykar unless stated otherwise. Downloads are licensed for your personal use only."],
      ["AI-generated content", "Responses from the AI tutor are generated automatically and may contain inaccuracies. They are provided for learning purposes without warranty."],
      ["Termination", "Access to the Tribe may be suspended or ended for accounts that violate these terms."],
      ["Changes", "These terms may be updated from time to time; continued use after changes means you accept the updated terms."],
      ["Contact", "Questions about these terms: hi@rosh.work"],
    ],
  },
};

export default function LegalPage({ kind }) {
  const s = SECTIONS[kind];
  return (
    <div className="min-h-screen" style={{ background: "#EDE7D9" }} data-testid={`legal-${kind}`}>
      <main className="max-w-3xl mx-auto px-6 py-14 md:py-20">
        <Link to="/" className="inline-flex items-center gap-2 mb-10 text-sm font-medium text-[#5C5042] hover:text-[#262016] transition-colors" data-testid="legal-back-home">
          <ArrowLeft size={15} /> Back to home
        </Link>
        <h1 className="rp-display text-4xl sm:text-5xl font-light text-[#262016] mb-2">{s.title}</h1>
        <p className="text-[11px] uppercase tracking-[0.18em] text-[#B5793F] font-medium mb-10">{s.updated}</p>
        <div className="rp-foam bg-white/55 p-7 md:p-10 space-y-7">
          {s.blocks.map(([h, p], i) => (
            <section key={i}>
              <h2 className="rp-display text-lg md:text-xl font-medium text-[#262016] mb-2">{h}</h2>
              <p className="text-sm md:text-[15px] leading-relaxed text-[#5C5042]" style={{ textWrap: "pretty" }}>{p}</p>
            </section>
          ))}
        </div>
      </main>
    </div>
  );
}
